
/**
 * 응답 데이터
 * @nullable
 */
export type ApiResponseData = { [key: string]: unknown } | null;
